export enum PaymentRequestQueryType {
  forPeriod,
  byArrival
}

export class PaymentRequestDTO {
  Period: string;
  Type: PaymentRequestQueryType;
}
